import { RoleDto, RoleTypeEnum } from '../commonTypes/user.types';

export const checkIfAdminOwner = (loggedUserRole: RoleDto) => {
    return loggedUserRole.name === RoleTypeEnum.ADMIN || loggedUserRole.name === RoleTypeEnum.OWNER;
};

export const checkIfAdminOwnerMeExcluded = (loggedUserRole: RoleDto, loggedUserUserSub: string, profilesUserSub: string) => {
    if (loggedUserUserSub === profilesUserSub) return false;
    if (loggedUserRole.name !== RoleTypeEnum.ADMIN && loggedUserRole.name !== RoleTypeEnum.OWNER) return false;
    return true;
};
